/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
import NodŜarĝilo from './NodŜarĝilo.js';
import Nodo from './Nodo.js';
import Vorto from './Vorto.js';
import Table from 'react-bootstrap/Table';
import Container from 'react-bootstrap/Container';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { useState } from 'react';
import Alert from 'react-bootstrap/Alert';
import { useContext } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import {TEKSTOJ} from './tekstoj.js';
import {LINGVOJ} from './Lingvoj.js';
import Lingvo from './Lingvo.js';

import {FasadaLingvoKunteksto, VortaroLingvojKunteksto} from './Kunteksto.js';

function VortMontrilo ( {modVorto, agorduModVorton, nodŝarĝilo} )
{       
  const handleClose = () => agorduModVorton ({vorto:modVorto.vorto, montri:false});
  console.log (modVorto);
  let vorto = modVorto.vorto;
  let vorto_teksto = vorto !== null ? formatitaVorto(vorto.vorto) : '';
  let vorto_titolo = vorto !== null ? vorto.vorto : TEKSTOJ.teksto('VORTO_NENIU');
  let vorto_lingvo = vorto !== null ? LINGVOJ.lingvo(vorto.lingvo).nacinomo : LINGVOJ.lingvo (modVorto.lingvo).nacinomo;
  let sekcio_priskribo = <><label htmlFor="priskribo">{TEKSTOJ.teksto('PRISKRIBO')}</label>:<br />
        <div dangerouslySetInnerHTML={vorto_teksto} />
        </>;
        
  return (
      <Modal show={modVorto.montri} onHide={handleClose} centered={true} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>{vorto_titolo}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <label>{TEKSTOJ.teksto('LINGVO')}</label>: {vorto_lingvo}<br />
        <label htmlFor="vorto">{TEKSTOJ.teksto('ESPRIMO')}</label>:<br />
        <div dangerouslySetInnerHTML={vorto_teksto} />
        {sekcio_priskribo}
    </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>{TEKSTOJ.teksto('BUTONO_FERMU')}</Button>
        </Modal.Footer>
      </Modal>
  );  
}

function formatitaVorto (vorto)
{
    let vorto_html1 = vorto.replace ('[[', '<span class="trovita">');
    let vorto_html2 = vorto_html1.replace (']]', '</span>');
    let vorto_html3 = vorto_html2.replace ('{', '<span class="lingvajnotoj">');
    let vorto_html = vorto_html3.replace ('}', '</span>');    
    
    return ({__html: vorto_html});
}

function VortaroĈapitro ({nodoid, vorto})
{
    var vorto_html = formatitaVorto (vorto);
    return (<h2 dangerouslySetInnerHTML={vorto_html} />);    
}

function VortaroSubĉapitro  ({nodoid, vorto})
{
    var vorto_html = formatitaVorto (vorto);
    return (<h3 dangerouslySetInnerHTML={vorto_html} />);    
   // var vorto_html = formatitaVorto (vorto);
   // return (<h3>{children}</h3>);    
}

function VortaroSubsubĉapitro  ({nodoid, vorto})
{
    var vorto_html = formatitaVorto (vorto);
    return (<h4 dangerouslySetInnerHTML={vorto_html} />);    
    // return (<h4>{children}</h4>);    
}

function VortaroKapvorto  ({alklakante, nodoid, vorto})
{
    var vorto_html = formatitaVorto (vorto);
    return (<span className="kapvorto" onClick={alklakante} dangerouslySetInnerHTML={vorto_html} />);    
    //return (<strong>{children}</strong>);    
}

function VortaroKategorio ({nodoid, kategorio, nodŝarĝilo})
{
    var simbolo = '';
    var titolo = TEKSTOJ.teksto('KATEGORIO') + ' ' + kategorio;
    var kolorklaso = '';
    switch (kategorio)
    {
        case 5: simbolo = '♠';
                titolo = TEKSTOJ.teksto('KATEGORIO_TIPOJ');
                kolorklaso = 'tipo';
            break;
        case 6: simbolo = '♣';
            titolo = TEKSTOJ.teksto('KATEGORIO_VERBOJ');
            kolorklaso = 'verbo';
            break;
        case 7: simbolo = '♥';
            titolo = TEKSTOJ.teksto('KATEGORIO_ADJEKTIVOJ');
            kolorklaso = 'adjektivo';
            break;
        case 8: simbolo = '♦';
            titolo = TEKSTOJ.teksto('KATEGORIO_ASOCIEBLAJ');
            kolorklaso = 'asociebla';
            break;
        case 11: simbolo = '☼';
            titolo = TEKSTOJ.teksto('KATEGORIO_PARTOJ');
            kolorklaso = 'parto';
    }    
    
    function alklakante ()
    {
        return (function (e){
            nodŝarĝilo.reŝarĝuNodojnKunKategorioj (nodoid, kategorio);
            e.stopPropagation();
        });
    }
    
    var alklakante = alklakante();
    return <span className= {"kategorio " + kolorklaso} onClick={alklakante}>{simbolo}&nbsp;{titolo}</span> 
}

function VortaroVorto  ({alklakante, nodoid, kategorio, vorto})
{
    var simbolo = '';
    let vorto_html = formatitaVorto (vorto);
    switch (kategorio)
    {
        case 5: simbolo = '♠';
            break;
        case 6: simbolo = '♣';
            break;
        case 7: simbolo = '♥';
            break;
        case 8: simbolo = '♦';
            break;
        case 11: simbolo = '☼';
    }
//    return (<><span>{simbolo}</span>&nbsp;<span dangerouslySetInnerHTML={{ __html: {vorto_html} }} /></>);
    return (<>&nbsp;<span>{simbolo}</span>&nbsp;<span className="vorto" onClick={alklakante} dangerouslySetInnerHTML={vorto_html} /></>);
}

function VortaroSubordigita ({alklakante, nodoid, vorto})
{
     let vorto_html = formatitaVorto (vorto);
     return (<span className="subvorto" onClick={alklakante} dangerouslySetInnerHTML={vorto_html} />);
}

function VortaroFormatita  ({alklakante, kategorio, vorto})
{
     switch (kategorio)
    {
        case 1: return (<VortaroĈapitro alklakante={alklakante} vorto={vorto} />);
        case 2: return (<VortaroSubĉapitro alklakante={alklakante} vorto={vorto} />);
        case 3: return (<VortaroSubsubĉapitro alklakante={alklakante} vorto={vorto} />);
        case 4: return (<VortaroKapvorto alklakante={alklakante} vorto={vorto} />);    
        case 9: return (<VortaroSubordigita alklakante={alklakante} vorto={vorto} />);
        case 10: return (<VortaroKategorio alklakante={alklakante} vorto={vorto} />);
        default: return (<VortaroVorto alklakante={alklakante} kategorio={kategorio} vorto={vorto} />);
    }   
}

function VortaroKielKapo ({kategorio, vortoj})
{
    var vortlisto = [];
    for (var vorto of vortoj)
        {
            vortlisto.push (vorto.vorto);
        }
    var vortoj_komo = vortlisto.join(', ');
    return (<VortaroFormatita kategorio={kategorio} vorto={vortoj_komo} />);
}

function montruVorton (vorto, agorduModVorton)
{
    return (function(e){
        agorduModVorton ({'vorto' : vorto, montri: true});
        //alert ('Vorto ' + vorto.id + ":\n" + vorto.vorto);
        e.stopPropagation();
    });
}

function VortaroKielListo ({agorduModVorton, kategorio, vortoj})
{
   var stilo;
    switch (kategorio)
    {
        case 4: stilo = "kapvorto";break;
        case 9: stilo = "subvorto";break;
        case 5: stilo = "vorto tipo";break;
        case 6: stilo = "vorto verbo";break;
        case 7: stilo = "vorto adjektivo";break;
        case 8: stilo = "vorto asociebla";break;
        case 11: stilo = "vorto parto";break;
        default: stilo = "vorto";
    }
    
    if (vortoj.length === 1)
    {
        let vorto = vortoj[0];
        var alklakante = montruVorton (vorto, agorduModVorton);
        return (<div className={stilo}><VortaroFormatita alklakante={alklakante} kategorio={kategorio} vorto={vorto.vorto} /></div>);
    }
    else
    {
        var vortlisto = [];
        for (var vorto of vortoj)
        {
            var alklakante = montruVorton (vorto, agorduModVorton);
            vortlisto.push (<li key={vorto.id}><VortaroFormatita  alklakante={alklakante} kategorio={kategorio} vorto={vorto.vorto} /></li>);
        }
        return (<ol className={stilo}>{vortlisto}</ol>);
    }
}

function VortaroKapvortajKategorioj ({nodo, nodŝarĝilo})
{
    console.log ("kategorioj = " + nodo.kategorioj);
    if (nodo.kategorioj === null)
    {
        return;
    }
    var katlisto = [];
    for (var kategorio of nodo.kategorioj)
    {
        katlisto.push (<VortaroKategorio id={"kapvortakat-" + nodo.id + '-' + kategorio} nodoid={nodo.id} kategorio={parseInt(kategorio)} nodŝarĝilo={nodŝarĝilo} />);
    }
    
    return (<>{katlisto}</>);
}

function VortaroVortoj ({kategorio,  agorduModVorton, kat_filoj, vortoj})
{
    switch (kategorio)
    {
        case 1: 
        case 2: 
        case 3: return (<VortaroKielKapo kategorio={kategorio} vortoj={vortoj} />);
        case 4: 
        case 9: 
        default: return (<VortaroKielListo agorduModVorton={agorduModVorton} kategorio={kategorio} vortoj={vortoj} />);
    }
}

function VortaroNodo ({nodo, agorduModVorton, nodŝarĝilo, estasKapo = false})
{
    const {vortarlingvoj, agorduVortarLingvojn} = useContext (VortaroLingvojKunteksto);
    var lingvoj = vortarlingvoj;
    
    var kolumnoj = [];
    
    var sago = nodo.fina ? '⏊' : (estasKapo ? '↑' : '→');
    for (var lingvo of lingvoj)
    {
        var vortoj = nodo.vortojPorLingvo(lingvo);
//        var klaso = estasKapo ? 'kapo' : (nodo.kategorio == 10 ?  "kategorio" : '');
        var klaso = estasKapo ? 'kapo' : '';
        var kategoriajButonoj = nodo.kategorio == 4 ? <VortaroKapvortajKategorioj nodo={nodo} nodŝarĝilo={nodŝarĝilo} /> : <></>;
        kolumnoj.push (<td className={klaso} key={nodo.id + "-" + lingvo}><VortaroVortoj agorduModVorton={agorduModVorton} kategorio={nodo.kategorio} kat_filoj={nodo.kategorio_filoj} vortoj={vortoj} />{kategoriajButonoj}<span className="sago">{sago}</span></td>);
    }
    function alklakante ()
    {
        nodŝarĝilo.ŝarĝuNodojn (estasKapo ? nodo.patro_id : nodo.id);
    }
    
    if (nodo.fina)
    {
    return (//obalit <>, aby šly přidat i potomci
       <tr>
           {kolumnoj}
      </tr>           
            );   
    }
    else
    {
    return (//obalit <>, aby šly přidat i potomci
       <tr onClick={alklakante}>
           {kolumnoj}
      </tr>
            );           
    }
}

function kategorioKielSignovico (kategorio)
{
    var simbolo = '';
    var titolo = 'Kategorio ' + kategorio;
    switch (kategorio)
    {
        case 5: simbolo = '♠';
                titolo = 'tipoj';
            break;
        case 6: simbolo = '♣';
            titolo = 'verboj'
            break;
        case 7: simbolo = '♥';
            titolo = 'adjektivoj';
            break;
        case 8: simbolo = '♦';
            titolo = 'asocieblaj';
            break;
        case 11: simbolo = '☼';
            titolo = 'partoj';           
    }    
    return (simbolo + " " + titolo);
}

function PaĝnivelaNavigilero ({nodo, nodŝarĝilo})
{
    const {vortarlingvoj, agorduVortarLingvojn} = useContext (VortaroLingvojKunteksto);
    var lingvoj = vortarlingvoj;
    var lingvo = lingvoj[0];
    var ĉefvorto;
    
    if (nodo.kategorio == 10)
    {
        ĉefvorto = kategorioKielSignovico (nodo.kategorio_filoj)
    }
    else
    {
        var vortoj = nodo.vortojPorLingvo(lingvo);
        ĉefvorto = (vortoj.length > 0) ? vortoj[0].vorto : '?';
    }
    function alklakante ()
    {
        nodŝarĝilo.ŝarĝuNodojn (nodo.id);
    }
    return (
    <Breadcrumb.Item href="#" onClick={alklakante}>{ĉefvorto}</Breadcrumb.Item>
            );           
}

function PaĝnivelaNavigilo ({kapnodoj, nodŝarĝilo})
{
    function alklakante ()
    {
        nodŝarĝilo.ŝarĝuNodojn (null);
    }
    
    if (kapnodoj !== null)
    {
       var kapnodlisto = [];
       for (var nodo of kapnodoj)
       {
           kapnodlisto.push (<PaĝnivelaNavigilero key={"pn" + nodo.id} nodŝarĝilo={nodŝarĝilo} nodo={nodo} />);
       }
       return (
               <Breadcrumb>
                 <Breadcrumb.Item href="#" onClick={alklakante}>Hejmen</Breadcrumb.Item>
                {kapnodlisto}
                </Breadcrumb>             
       );
    }
}

function Vortaro( {nodoj, nodŝarĝilo})
{
    const {vortarlingvoj, agorduVortarLingvojn} = useContext (VortaroLingvojKunteksto);
    const [modVorto, agorduModVorton] = useState ({vorto: null, montri: false});
    var lingvoj = vortarlingvoj;
    
    var kapLingvoj = [];
    for (var lingvo of lingvoj)
    {
        var nomoDeLingvo = LINGVOJ.lingvo(lingvo).nacinomo;
        kapLingvoj.push (<th key={lingvo}>{nomoDeLingvo}</th>);
    }
    
   nodŝarĝilo.agorduLingvojn (lingvoj); 
   if (nodoj === null)
   {
       nodŝarĝilo.ŝarĝuNodojn (null);
       return(<Alert dismissible variant="danger">
      <Alert.Heading>Neniu nodo trovita</Alert.Heading>
      <p>Atentu, eble mi ŝarĝas datumojn.</p>
    </Alert>
    );
   }
   else
   {
       var kapnodlisto = [];
       for (var nodo of nodoj.kapnodoj)
       {
           kapnodlisto.push (<VortaroNodo key={nodo.id} agorduModVorton={agorduModVorton} nodŝarĝilo={nodŝarĝilo} nodo={nodo}  estasKapo={true} />);
       }
       
       
       var nodlisto = [];
       for (var nodo of nodoj.listo)
       {
           nodlisto.push (<VortaroNodo key={nodo.id} agorduModVorton={agorduModVorton} nodŝarĝilo={nodŝarĝilo} nodo={nodo} />);
       }
       var kapo;
       if (nodoj.kapnodoj !== null)
       {
           kapo = <thead>
           <tr>{kapLingvoj}</tr>
               {kapnodlisto}
            </thead>;
       }
       else
       {
            kapo = <thead>
            <tr>{kapLingvoj}</tr>              
            </thead>;          
       }
       
       return (
               <>
       <VortMontrilo modVorto={modVorto} agorduModVorton={agorduModVorton}  nodŝarĝilo={nodŝarĝilo} />
       <PaĝnivelaNavigilo kapnodoj={nodoj.kapnodoj} nodŝarĝilo={nodŝarĝilo} /> 
       <div className="vortaro">`
    <Table striped bordered hover>
        {kapo}
        <tbody>
        {nodlisto}
        </tbody>
    </Table>
    </div>
    </>
               );       
   }
}

export default Vortaro;